// https://gist.github.com/nmsdvid/8807205
export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}


export function setCss(elements, styles, value = null) {

    if (typeof styles === 'string' && value !== null) {
        styles = {
            [styles]: value
        };
    }

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    });
}


/**
 * @since 2024-05-06 first param containers could be an array
 */
export function setLoading(containers, loading) {

    if (!Array.isArray(containers)) {
        containers = [containers];
    }

    containers.forEach(container => {
        let isStatic = window.getComputedStyle(container).position === 'static';

        if (loading) {
            if (isStatic) {
                container.style.position = 'relative';
            }
            container.classList.add('is-loading');
            
        } else {
            container.classList.remove('is-loading');
        }
    });
}

export function onDelegatedClick(parent, selector, callback, useCapture) {
    return onDelegatedEvent('click', parent, selector, callback, useCapture);
}

export function onDelegatedEvent(eventName, parent, selector, callback, useCapture) {
    return parent.addEventListener(eventName, function(e) {

        let selectorTarget = e.target.closest(selector);

        if (!selectorTarget) {
            return;
        }

        e.selectorTarget = selectorTarget;

        callback(e);
        
    }, useCapture);
}

export function onClick(element, callback) {
    return element.addEventListener('click', function(e) {
        callback(e);
    });
}


export function viewTransition(callback) {
    if (document.startViewTransition) {
        document.startViewTransition(() => {
            callback();
        });
    } else {
        callback();
    }
}

export function tryJsonParse(str) {
    try {
        return JSON.parse(str);
    } catch(e) {
        return null;
    }
}

export function html(strings, ...values) {
    let str = '';
    strings.forEach((string, i) => {
        str += string + (values[i] || '');
    });
    return str;
}

export function onClickOutside(domElement, callback) {
    document.addEventListener('click', event => {
        if (!domElement.contains(event.target)) {
            callback(event);
        }
    });
}